const Providers = ({ providers = [], children }) => {
    return (
        <>
            {providers.reduceRight(
                (children, Provider) => (
                    <Provider>{children}</Provider>
                ),
                children
            )}
        </>
    );
};

export default Providers;
